import DateTimeCell from 'pages/event-list-page/event-table-cells/date-time-cell';
import { Column } from 'react-table';
import { DateColumnFilter, SelectColumnFilter, SelectOptionType } from 'utils/react-table';
import JsonFormatCell from './components/json-format-cell';
import { SortingType } from 'components/base-table/dto';

const operationTypesOptions : SelectOptionType[] = [
    {label:"Create", value:"Create"},
    {label:"Update", value:"Update"},
    {label:"Delete", value:"Delete"},
]

const PublishStatusOptions : SelectOptionType[] = [
    {label:"Draft", value:"Draft"},
    {label:"Published", value:"Published"},
]

const CalendarHistoryTableColumnConfig: Column[] = [
    {
        Header: 'Timestamp UTC',
        accessor: 'timestampUTC',
        disableSortBy: false,
        Filter: DateColumnFilter,
        Cell: DateTimeCell,
    },
    {
        Header: 'Event ID',
        accessor: 'eventId',
        disableSortBy: false,
    },
    {
        Header: 'User',
        accessor: 'userTrigram',
    },
    {
        Header: 'Operation Type',
        accessor: 'operationType',
        Filter: (props) => <SelectColumnFilter {...props} options={operationTypesOptions} />
    },
    {
        Header: 'Publish Status',
        accessor: 'publishStatus',
        Filter: (props) => <SelectColumnFilter {...props} options={PublishStatusOptions} />
    },
    {
        Header: 'Log Data',
        accessor: 'changeData',
        disableFilters: true,
        Cell: JsonFormatCell,
    },
];

export default CalendarHistoryTableColumnConfig;

export const DefaultVisibleCalendarHistoryColumns = [
    'timestampUTC',
    'eventId',
    'userTrigram',
    'publishStatus',
    'operationType',
    'changeData',
];

export const SearchableCalendarHistoryTableColumnConfig = ['eventId', 'userTrigram'];
export const DefaultCalendarHistoryTableColumnIdToSortBy = 'timestampUTC';
export const DefaultCalendarHistoryTableSortingType = SortingType.Descending
